import React from 'react';
import styles from './Footer.module.scss';

import { MainButton } from 'components/StyledComponents';

import { useParams } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';

import { FORM_FIELDS, REQUEST_STATUSES } from '../../helpers';

export function Footer({ onCancel, onEdit, onResolve, onReopen }) {
  const { id } = useParams();

  const { formState, getValues } = useFormContext();
  const { errors } = formState;

  const isFormInvalid = !!Object.values(errors).filter(Boolean).length;

  const status = getValues(FORM_FIELDS.STATUS);
  const isRequestOpened = status?.name === REQUEST_STATUSES.OPENED;
  const isRequestResolved = status?.name === REQUEST_STATUSES.RESOLVED;

  return (
    <div className={styles.footer}>
      <MainButton text="cancel" type="secondary" action={onCancel} />
      <MainButton
        text={id ? 'save' : 'create'}
        type="primary"
        action={onEdit}
        isDisabled={isFormInvalid}
      />
      {!!id && isRequestOpened && (
        <MainButton
          text="resolve request"
          type="primary"
          action={onResolve}
          isDisabled={isFormInvalid}
        />
      )}
      {!!id && isRequestResolved && (
        <MainButton
          text="reopen request"
          type="primary"
          action={onReopen}
          isDisabled={isFormInvalid}
        />
      )}
    </div>
  );
}
